import { useCan } from "./useCan";

/**
 * Returns `true` when the signed-in user is a Super Admin (read-only).
 *
 * Super Admin in this app is identified by the `superadmin.dashboard`
 * permission. Crew/master/officer roles do not have it, so this is a
 * reliable, role-agnostic signal we can use to:
 *   - hide "New Entry" CTAs from list/history pages, and
 *   - bounce direct URL hits to creation/form routes.
 *
 * The hook also exposes `loading` so callers can avoid flashing a guarded
 * page while permissions are still being fetched.
 */
export const useIsReadOnlyAdmin = () => {
  const adminPerm = useCan("superadmin.dashboard");
  return {
    isReadOnlyAdmin: !!adminPerm.canView,
    loading: !!adminPerm.loading,
  };
};

export default useIsReadOnlyAdmin;
